import { render, staticRenderFns } from "./TdcV1.vue?vue&type=template&id=2c58a983&scoped=true&"
import script from "./TdcV1.vue?vue&type=script&lang=js&"
export * from "./TdcV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58a983",
  null
  
)

export default component.exports